import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["messageInput", "charHint", "charLimitReached"];

  updateCondolenceMessage(event) {
    const maxLength = parseInt(this.messageInputTarget.getAttribute("maxlength"), 10);
    const value = event.target.value;
    this.messageInputTarget.value = maxLength ? value.slice(0, maxLength) : value;
    this.updateCharCount();
  }

  updateCharCount() {
    if (!this.hasCharHintTarget || !this.hasCharLimitReachedTarget || !this.hasMessageInputTarget) return;

    const maxLength = parseInt(this.messageInputTarget.getAttribute("maxlength"), 10);
    if (!maxLength) return;

    const limitReached = this.messageInputTarget.value.length >= maxLength;

    this.charHintTarget.classList.toggle("hidden", limitReached);
    this.charLimitReachedTarget.classList.toggle("hidden", !limitReached);
  }
}
